import { csatStore as e } from "./csatStore.mjs";
import { csatQueryKeys as t } from "./queryKeys.mjs";
import { useCsatEligibilityQuery as n } from "./useCsatEligibilityQuery.mjs";
import { useQueryClient as r } from "@maat/store-hooks";
import { csatApi as i } from "@maat/api-csat";
import { useCallback as a, useEffect as o, useRef as s } from "react";
import { useAuth as c } from "@maat/store-auth";
//#region src/useCSAT.ts
var l = 4e3, u = ({ feature: u, trigger: d = "manual", delayMs: f = l, metadata: p }) => {
	let m = r(), { isAuthenticated: h, activeProfile: g } = c(), _ = n(u).data?.eligible === !0, v = s(!1), y = s(p);
	y.current = p;
	let b = h && (g === "guest" || g === "host"), x = a(async () => {
		if (!b || v.current || e.getSnapshot() !== null || m.getQueryData(t.eligibility(u))?.eligible === !1) return !1;
		v.current = !0;
		try {
			let t = await i.claimPrompt({ feature: u });
			if (t.allowed && t.prompt_id) return e.open({
				feature: u,
				promptId: t.prompt_id,
				metadata: y.current
			}), !0;
		} catch {}
		return m.setQueryData(t.eligibility(u), { eligible: !1 }), !1;
	}, [
		b,
		u,
		m
	]);
	return o(() => {
		if (d !== "mount" || !_ || v.current) return;
		let e = setTimeout(() => {
			x();
		}, f);
		return () => clearTimeout(e);
	}, [
		d,
		_,
		f,
		x
	]), {
		promptCsat: x,
		isEligible: _
	};
};
//#endregion
export { u as useCSAT };
